import React, { useLayoutEffect, useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import CandidateModal from '../../plateform/recruiter/components/Modal/CandidateModal';

const DropdownStatus = ({appointementStatus, application, setApplicationSelected, setDisplayModal, ...props}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [status, setStatus] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(true)
  const dropdown = useRef(null)
  const trigger = useRef(null)

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  }

    // close on click outside
    useEffect(() => {
        // const clickHandler = ({ target }) => {
        //   if (!dropdown.current) return;
        //   if (
        //     !showModal ||
        //     dropdown.current.contains(target) ||
        //     trigger.current.contains(target)
        //   )
        //     return;
        //     setShowModal(false);
        // }
        // document.addEventListener("click", clickHandler);
        // return () => document.removeEventListener("click", clickHandler);
        const handleClickOutside = ({ target }) => {
          if (
            dropdown.current &&
            !dropdown.current.contains(target) &&
            !trigger.current.contains(target)
          ) {
            setIsOpen(false);
          }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
      })

  const menuItems = [ 
    // {
    // label: 'Nouveau',
    // action: "unkown"},
    {
     label:'Sélectionner',
    action: "ConfirmSelectionModal"
    },
    {
      label:'Entretien',
     action: "InterviewScheduler"
     },
     {
      label:'Récruter',
     action: "ConfirmRecrutementModal"
     },
     {
      label:'Réfuser',
     action: "DeclineApplicationModal"
     },
  // 'Entretien',
  // 'Récruter', 
  // 'Réfuser'
]

  useLayoutEffect(() => {
    setStatus(appointementStatus)
  
  }, [appointementStatus])

  // useEffect(() => {
  //   return () => {
  //     handleCloseModal();
  //     handleDeleteCloseModal();
  //   };
  // }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleDeleteCloseModal = () => {
    setShowDeleteModal(false);
  };
  const handleDeleteOpenModal = () => {
    setShowDeleteModal(true);
  };
  

  return (
    <div className="relative inline-block text-left text-sm" {...props}>
      <div className="flex items-center">
        {status !== "Confirmé" ?
        <button
          onClick={() =>  setDisplayModal(2)}

          className="px-4 py-2 text-primary-text bg-neutral-50 border rounded-l-md focus:outline-none text-sm"
        >
           Sélectionner
        </button>
        :
        <button
          onClick={() => setDisplayModal(6)}
          className="px-4 py-2  bg-[#F6F8FA]  border text-[#24292F] rounded-l-md hover:bg-neutral-200 focus:outline-none text-sm"

        >
          Réfuser
        </button>
        }
        
        <button
        //   onClick={toggleDropdown}
          ref={trigger}
          onFocus={() => setIsOpen(true)}
          //   onBlur={() => setIsOpen(false)}
          className={ (status !== "Confirmé") ? " text-primary-text bg-neutral-50 border px-3 py-[10px] text-white rounded-r-md focus:outline-none flex items-center border-l ": " bg-[#F6F8FA] px-3 py-[10px] text-gray-500 rounded-r-md focus:outline-none flex items-center border border-l-transparent border-l-gray-300 "}

        >
          <FaChevronDown className={`text-primary-text transition-transform ${isOpen ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {isOpen && (
        <div
        ref={dropdown}
        className="absolute z-30 right-0 mt-2 w-48 bg-white border rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="flex flex-col">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                setDisplayModal(item.action);
                setApplicationSelected(application)
                setIsOpen(false);
                }}
                className={"w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 focus:outline-none  text-sm"+((item === "Réfuser")?" text-red-600 hover:bg-red-50 ":" text-gray-900")}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}



      </div>
  )
}

export default DropdownStatus

// import React, { useLayoutEffect, useState, useEffect, useRef } from 'react';
// import { FaChevronDown } from 'react-icons/fa';
// import CandidateModal from '../../plateform/recruiter/components/Modal/CandidateModal';

// const DropdownStatus = ({appointementStatus,  setDisplayModal, ...props}) => {
//   const [isOpen, setIsOpen] = useState(false)
//   const [showModal, setShowModal] = useState(false)
//   const [status, setStatus] = useState(null)
//   const [showDeleteModal, setShowDeleteModal] = useState(true)
//   const dropdown = useRef(null)
//   const trigger = useRef(null)

//   const toggleDropdown = () => {
//     setIsOpen(!isOpen);
//   }

//     // close on click outside
//     useEffect(() => {
//         // const clickHandler = ({ target }) => {
//         //   if (!dropdown.current) return;
//         //   if (
//         //     !showModal ||
//         //     dropdown.current.contains(target) ||
//         //     trigger.current.contains(target)
//         //   )
//         //     return;
//         //     setShowModal(false);
//         // }
//         // document.addEventListener("click", clickHandler);
//         // return () => document.removeEventListener("click", clickHandler);
//         const handleClickOutside = ({ target }) => {
//           if (
//             dropdown.current &&
//             !dropdown.current.contains(target) &&
//             !trigger.current.contains(target)
//           ) {
//             setIsOpen(false);
//           }
//         };
//         document.addEventListener("click", handleClickOutside);
//         return () => document.removeEventListener("click", handleClickOutside);
//       })

//   const menuItems = [ 'Nouveau','Sélectionner','Entretien','Récruter', 'Réfuser']

//   useLayoutEffect(() => {
//     setStatus(appointementStatus)
  
//   }, [appointementStatus])

//   // useEffect(() => {
//   //   return () => {
//   //     handleCloseModal();
//   //     handleDeleteCloseModal();
//   //   };
//   // }, []);

//   const handleCloseModal = () => {
//     setShowModal(false);
//   };
  
//   const handleDeleteCloseModal = () => {
//     setShowDeleteModal(false);
//   };
//   const handleDeleteOpenModal = () => {
//     setShowDeleteModal(true);
//   };
  

//   return (
//     <div className="relative inline-block text-left text-sm" {...props}>
//       <div className="flex items-center">
//         {status !== "Confirmé" ?
//         <button
//           onClick={() =>  setDisplayModal(2)}

//           className="px-4 py-2 text-primary-text bg-neutral-50 border rounded-l-md focus:outline-none text-sm"
//         >
//            Sélectionner
//         </button>
//         :
//         <button
//           onClick={() => setDisplayModal(6)}
//           className="px-4 py-2  bg-[#F6F8FA]  border text-[#24292F] rounded-l-md hover:bg-neutral-200 focus:outline-none text-sm"

//         >
//           Réfuser
//         </button>
//         }
        
//         <button
//         //   onClick={toggleDropdown}
//           ref={trigger}
//           onFocus={() => setIsOpen(true)}
//           //   onBlur={() => setIsOpen(false)}
//           className={ (status !== "Confirmé") ? " text-primary-text bg-neutral-50 border px-3 py-[10px] text-white rounded-r-md focus:outline-none flex items-center border-l ": " bg-[#F6F8FA] px-3 py-[10px] text-gray-500 rounded-r-md focus:outline-none flex items-center border border-l-transparent border-l-gray-300 "}

//         >
//           <FaChevronDown className={`text-primary-text transition-transform ${isOpen ? 'rotate-180' : ''}`} />
//         </button>
//       </div>

//       {isOpen && (
//         <div
//         ref={dropdown}
//         className="absolute z-30 right-0 mt-2 w-48 bg-white border rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//           <div className="flex flex-col">
//             {menuItems.map((item, index) => (
//               <button
//                 key={index}
//                 onClick={() => {
//                   setDisplayModal(index);
//                 setIsOpen(false);
//                 }}
//                 className={"w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 focus:outline-none  text-sm"+((item === "Réfuser")?" text-red-600 hover:bg-red-50 ":" text-gray-900")}
//               >
//                 {item}
//               </button>
//             ))}
//           </div>
//         </div>
//       )}



//       </div>
//   )
// }

// export default DropdownStatus